import { useFormik } from 'formik';
import IBAN from 'iban';
import React, { useEffect, useState } from 'react';
import { IoSearch } from 'react-icons/io5';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import RequiredInput from '../../components/forms/InputHOC';
import PhoneInput from '../../components/forms/PhoneInputWrapper';
import Page from '../../layout/Page/Page';
import FormGroup from '../../layout/shared/form-group';
import { Client } from '../../type/entities/client-type';
import { validateCifNif, validateSS } from '../../utils/validatorFunctions';
import FormFooter from '../_layout/_footers/form-footer';
import { Checkbox, Input, Switch } from 'rizzui';

interface ClientFormProps {
    isLoading: boolean;
    submit: Function;
    data?: Client | undefined;
}

const schema = yup.object({
    name: yup.string().required('Campo obligatorio'),
    contactEmail: yup.string().email('Email no válido').required('Campo obligatorio'),
    contactPhone: yup.string().notRequired().test("valid-phone", "El teléfono no es válido", (value) => {
        if (value === undefined || value === '' || value === null) {
            return true;
        }
        return isValidPhoneNumber(value)
    }),
    status: yup.boolean().required('Campo obligatorio'),
});

const ClientForm: React.FC<ClientFormProps> = ({ isLoading, submit, data }) => {

    const mode = data ? 'Editar' : 'Crear';
    const navigate = useNavigate();


    const formik = useFormik({
        initialValues: {
            id: data?.id ?? '',
            company: data?.company.id ?? '',
            name: data?.name ?? '',
            contactName: data?.contactName ?? '',
            contactEmail: data?.contactEmail ?? '',
            contactPhone: data?.contactPhone ?? '',
            address: data?.address ?? '',
            status: data ? data?.status ? true : false : true,
        },
        validationSchema: schema,
        validateOnBlur: false,
        //validateOnChange: false,
        onSubmit: values => { 
            submit(values) 
        },
    });


    const getContent = () => {
        return (
            <>
                <div className="@container">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="grid gap-7 divide-y-2 divide-dashed divide-gray-200 font-medium">
                            <FormGroup
                                title="Información General"
                                description="Datos principales"
                                titleCols="@md:col-span-2"
                                childCols="@md:col-span-10 md:grid-cols-4"
                            >

                                <RequiredInput
                                    id='name'
                                    label="Nombre"
                                    formik={formik}
                                />

                                <Input
                                    id='address'
                                    label="Dirección"
                                    className="md:col-span-2"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                />

                                <Switch
                                    id='status'
                                    checked={formik.values.status}
                                    onChange={() => formik.setFieldValue('status', !formik.values.status)}
                                    label="Activo"
                                    labelPlacement='left'
                                    switchKnobClassName='bg-red-300'
                                    className='mt-6 lg:text-center'
                                />

                            </FormGroup>

                            <FormGroup
                                title="Contacto"
                                description="Datos del Contacto"
                                className='pt-6'
                                titleCols="@md:col-span-2"
                                childCols="@md:col-span-10 md:grid-cols-3"
                            >
                                <Input
                                    id='contactName'
                                    label="Nombre del contacto"
                                    value={formik.values.contactName}
                                    onChange={formik.handleChange}
                                />

                                <RequiredInput
                                    id='contactEmail'
                                    label="Email"
                                    formik={formik}
                                />

                                <PhoneInput
                                    id='contactPhone'
                                    label='Teléfono'
                                    onBlur={formik.handleBlur}
                                    onChange={e => { formik.setFieldValue('contactPhone', e) }}
                                    value={formik.values.contactPhone}
                                    error={formik.errors.contactPhone}
                                    required={false}
                                />

                            </FormGroup>
                        </div>
                    </form>
                </div>
            </>
        );
    };

    return (
        <>
            <Page container="fluid">
                {(mode === "Editar" && data) && getContent()}
                {mode === "Crear" && getContent()}
            </Page>
            <FormFooter
                submitBtnText={mode + ' Cliente'}
                handleCancelBtn={() => navigate(-1)}
                handleSubmitBtn={formik.submitForm}
                isLoading={isLoading}
            />
        </>
    );
};

export default ClientForm;